module.exports = __webpack_public_path__ + "img/MonstersGuidetoAnger-Cover-640.54123d1c.png";